<template>
    <span class="plataforma-badge" :style="{ '--plat-size': size }">
        <span v-if="config" class="plataforma-badge__icons" :style="rightOffsetEnabled ? 'min-width: 53.717px' : ''">
            <template v-for="(part, i) in config.parts" :key="i">
                <span v-if="part.plus" class="plataforma-badge__plus">+</span>
                <img
                    v-else-if="part.img"
                    :src="part.img"
                    :alt="config.label"
                    class="plataforma-badge__img"
                />
                <i
                    v-else
                    :class="[`${rightOffsetEnabled && config.parts.length == 1 ? 'mx-auto' : ''}`, part.icon, 'plataforma-badge__i', `plataforma-badge--${part.brand}`]"
                ></i>
            </template>
        </span>
        <i v-else class="ri-question-line plataforma-badge__i plataforma-badge--unknown"></i>

        <span v-if="showLabel" class="plataforma-badge__label">
            {{ config ? config.label : plataforma }}
        </span>
    </span>
</template>

<script>
// Mapa único de plataforma → rótulo + ícones de marca. Vive em
// `@/utils/plataforma` junto com os predicados de capacidade, para que rótulo,
// selo e regras de UI nunca divirjam.
import { PLATAFORMAS } from '@/utils/plataforma';

export default {
    name: 'PlataformaBadge',
    props: {
        plataforma: {
            type: String,
            default: '',
        },
        rightOffsetEnabled: {
            type: Boolean, 
            default: false
        },
        showLabel: {
            type: Boolean,
            default: false,
        },
        // Tamanho dos ícones (font-size); imagens acompanham via 1em.
        size: {
            type: String,
            default: '1.15rem',
        },
    },
    computed: {
        config() {
            return PLATAFORMAS[this.plataforma] ?? null;
        },
    },
};
</script>

<style scoped>
.plataforma-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    line-height: 1;
}

.plataforma-badge__icons {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    line-height: 1;
}

.plataforma-badge__i {
    font-size: var(--plat-size);
    line-height: 1;
}

.plataforma-badge__img {
    width: var(--plat-size);
    height: var(--plat-size);
    object-fit: contain;
    border-radius: 3px;
}

.plataforma-badge__plus {
    font-size: calc(var(--plat-size) * 0.7);
    font-weight: 700;
    color: var(--bs-secondary-color, #9aa0ac);
    line-height: 1;
}

.plataforma-badge__label {
    font-size: 0.9em;
    font-weight: 600;
}

/* Cores de marca */
.plataforma-badge--whatsapp {
    color: #25d366;
}

.plataforma-badge--meta {
    color: #0866ff;
}

.plataforma-badge--messenger {
    color: #0084ff;
}

/* Instagram usa o gradiente oficial recortado no glifo do ícone. */
.plataforma-badge--instagram {
    background: linear-gradient(45deg, #f9ce34 0%, #ee2a7b 45%, #6228d7 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
}

.plataforma-badge--unknown {
    color: var(--bs-secondary-color, #9aa0ac);
}
</style>
